import translations from './../translations/messages';
import i18n from './../translations/i18n';

export default function getError(field, type) {
    let message;

    if (window.locale && translations[window.locale].fields[field]) {
        field = translations[window.locale].fields[field];
    }

    switch(type) {
        case 'required':
            message = i18n.global.t('validations.required', { field });
            break;
        default:
            message = i18n.global.t('validations.invalid', { field });
            break;
    }

    return message;
}
